// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"_3bf50c88","link":"_73cce77f"};